// extracted by mini-css-extract-plugin
export default {"heading":"LandscapeAboutParticipantAddTemplate_heading__r5Zfb","buttonLink":"LandscapeAboutParticipantAddTemplate_buttonLink__icrZZ"};